import Vue from 'vue'

export default {
  state: {
    communications: {},
    asyncMessages: []
  },
  mutations: {
    addCommunication (state, communication) {
      Vue.set(state.communications, communication.id, communication)
    },
    addManyCommunications (state, communications) {
      communications.forEach(communication => {
        Vue.set(state.communications, communication.id, communication)
      })
    },
    addAsyncMessage (state, message) {
      /**
       * Message =
       * object_id:
       * message:
       * color: //default: none
       */
      state.asyncMessages.unshift(message)
    }
  },
  getters: {
    getCommunication: (state) => (id) => {
      if (id in state.communications) {
        return state.communications[id]
      }
    },
    getCommsByBatchId: (state) => (batchId) => {
      let commsList = Object.values(state.communications)
      return commsList.filter((comm) => {
        return comm.batch_id === batchId
      })
    },
    getAsyncMessagesById: (state) => (id) => {
      return state.asyncMessages.filter((message) => {
        return message.object_id === id
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/communications.js